import React, { useEffect } from 'react'
import clsx from 'clsx'
import throttle from 'lodash.throttle'
import dynamic from 'next/dynamic'
import Link from 'next/link'

import public_styles from '@/css/public.module.css'

const Header = () => {
  const handleScroll = throttle(() => {
    const headerDiv = document.querySelector(`.${public_styles.header}`)
    if (headerDiv !== null) {
      if (window.scrollY > 500) {
        headerDiv.classList.add('header--sticky')
      } else {
        headerDiv.classList.remove('header--sticky')
      }
    }
  }, 300)

  const Pages = () => {
    const DynamicHeaderWallet = dynamic(() => import('@/components/layout/HeaderWallet'), {
      ssr: false,
    })
    return (
      <div className={public_styles.header_pages}>
        <div className={public_styles.header_pages_list}>
          <Link href={'/provenance'} title={'Provenance'}>
            Provenance
          </Link>
        </div>
        <div className={public_styles.header_wallet_wrapper}>
          <DynamicHeaderWallet />
        </div>
      </div>
    )
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [handleScroll])

  return (
    <header className={clsx(public_styles.header)}>
      <div
        className={clsx(
          public_styles.container,
          public_styles.d_flex,
          public_styles.w100,
          public_styles.justify_content_between,
          public_styles.gutter_05,
          public_styles.align_items_center,
        )}
      >
        <Link href={'/'} title={'The Demo'} className={public_styles.header_logo}>
          <div className={public_styles.header__title}>
            <span>The Demo</span>
          </div>
        </Link>
        <div className={public_styles.header__wrapper}>
          <div className={public_styles.header__body}>
            <Pages />
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
